import { render } from "./UserCard.vue?vue&type=template&id=9618c2de"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
script.render = render

export default script